import { FC } from 'react'
import styled from 'styled-components'

import { Info, TypeStyle } from '@syconium/little-miss-figgy'

import { useLocalization } from '../../../../../../../../app/_providers/LocalizationProvider.client'
import { useTranslation } from '../../../../../../../../app/_providers/TranslationProvider.client'
import { useFixturesContext } from '../../../../../../../../brunswick/containers/fixtures'
import { intlPrettyCurrency } from '../../../../../../../../lib/utils'
import { StyledTooltip } from '../../shared-form-styles'
import { LogoFormContainer } from '../LogoFormContainer'

export const LogoColorDisplay: FC = () => {
  const { logoColorPrice, addLogoForm } = LogoFormContainer.useContainer()
  const { region, locale } = useLocalization()
  const {
    embroidery: {
      modal: {
        forms: { dtcLogoEmbroideryForm: fixtures },
      },
    },
  } = useTranslation()
  const { logoColorSelectionTooltip } = useFixturesContext()

  const price = intlPrettyCurrency({
    cents: logoColorPrice,
    region: region,
    locale: locale,
    truncateTrailingZeros: true,
  })

  const kind = addLogoForm.values?.logoFile?.digitizationSetting
  const logoColor =
    kind === 'BLACK_WHITE'
      ? fixtures.logoStrings.LOGO_BLACK_WHITE?.title
      : kind === 'COLOR'
      ? fixtures.logoStrings.LOGO_COLOR?.title
      : ''

  return (
    <Container>
      <Label>
        {fixtures.logoColorLabel}
        <StyledTooltip content={<>{logoColorSelectionTooltip}</>} placement='bottom-start'>
          <button type='button' aria-label={fixtures.ariaLabelLogoColorTooltip}>
            <Info height='12px' width='12px' fill='#282828' />
          </button>
        </StyledTooltip>
        <Span>{logoColor}</Span>
      </Label>
      <PriceLabel>{price}</PriceLabel>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${({ theme }) => theme.spacing(4)} 0;
`

const Label = styled.label`
  ${TypeStyle.css.headlineMicro}
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
  text-transform: uppercase;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  letter-spacing: 2px;
  line-height: 18px;
`

const Span = styled(TypeStyle.HeadlineMicro)`
  margin: 0;
  font-weight: 400;
  text-transform: capitalize;
  color: ${o => o.theme.color.deprecated.obsidianLight};
`

const PriceLabel = styled(TypeStyle.BodySmall)`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 20px;
`
